// eslint-disable-next-line no-restricted-imports
import { SaveClientOnboardingStatusDto_Input } from 'api/generated/graphql';
import { ClientOnboardingStatusType } from 'api/types/entity';
import { SaveOnboardingStatusParam } from 'api/types/params';

import { parseClientOnboardingStatusParam } from './parseClientOnboardingStatusParam';

export const parseSaveClientOnboardingStatusParam = (
  param: SaveOnboardingStatusParam<ClientOnboardingStatusType>
): SaveClientOnboardingStatusDto_Input => ({
  value: parseClientOnboardingStatusParam(param.value),
  versionNumber: param.versionNumber,
  result: param.result,
});
